import { ref, readonly } from 'vue'

const MOBILE_BREAKPOINT = 768 // Tailwind md breakpoint

// Module-level shared state (singleton across all consumers)
const isMobile = ref(false)
const mobileMenuOpen = ref(false)

// One-time media query initialization
let initialized = false

function initMediaQuery() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  const mq = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
  isMobile.value = mq.matches

  mq.addEventListener('change', (e) => {
    isMobile.value = e.matches
    // Auto-close mobile menu when switching to desktop
    if (!e.matches) {
      mobileMenuOpen.value = false
    }
  })
}

export function useMobileMenu() {
  initMediaQuery()

  const openMenu = () => { mobileMenuOpen.value = true }
  const closeMenu = () => { mobileMenuOpen.value = false }
  const toggleMenu = () => { mobileMenuOpen.value = !mobileMenuOpen.value }

  return {
    isMobile: readonly(isMobile),
    mobileMenuOpen: readonly(mobileMenuOpen),
    openMenu,
    closeMenu,
    toggleMenu,
  }
}
